import { ErrorHandler, LargeContentContainer, OverlayedLoader, SmallContentContainer } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Title, Stack } from '@optimus-web/core';
import { useTextMessagingConfiguration } from '../../queries';
import { TextMessagingContent } from './TextMessagingContent';

interface TextMessagingContentContainerProps {
    enterpriseId: string;
}

export const TextMessagingContentContainer = ({ enterpriseId }: TextMessagingContentContainerProps) => {
    const { data, isFetching } = useTextMessagingConfiguration({ enterpriseId });
    const configurationData = data;

    if (configurationData == null) {
        if (isFetching) {
            return <OverlayedLoader show />;
        }
        return <ErrorHandler />;
    }

    const ContentContainer = configurationData == null ? LargeContentContainer : SmallContentContainer;

    return (
        <>
            <ContentContainer>
                <Stack spacing="300" vertical>
                    <Title level={2}>
                        <LocalizedText textKey={TextKey.TextMessaging} />
                    </Title>
                    <TextMessagingContent
                        enterpriseId={enterpriseId}
                        configuration={configurationData.configuration}
                        smsUsaRegistration={configurationData.smsUsaRegistration}
                    />
                </Stack>
            </ContentContainer>
        </>
    );
};
